// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AuditAccessLogData,
  AuditAccessLogResponses,
  AuditConfigData,
  AuditConfigResponses,
  AuditEntriesData,
  AuditEntriesResponses,
  AuthLoginData,
  AuthLoginResponses,
  AuthLogoutAllData,
  AuthLogoutAllResponses,
  AuthLogoutData,
  AuthLogoutResponses,
  AuthRefreshData,
  AuthRefreshResponses,
  BoricaBridgeBridgeData,
  BoricaBridgeBridgeResponses,
  BoricaCallbackReceiveData,
  BoricaCallbackReceiveResponses,
  EmailAttachmentByContentIdData,
  EmailAttachmentByContentIdResponses,
  EmailAttachmentByIndexData,
  EmailAttachmentByIndexResponses,
  EmailAttachmentSaveToFileData,
  EmailAttachmentSaveToFileResponses,
  EmailDetailData,
  EmailDetailResponses,
  EmailInboxData,
  EmailInboxResponses,
  EmailLinkLinkData,
  EmailLinkLinkResponses,
  EmailLinkUnlinkData,
  EmailLinkUnlinkResponses,
  EmailListData,
  EmailListResponses,
  EmailOutboxData,
  EmailOutboxResponses,
  EmailSendData,
  EmailSendResponses,
  FileDeleteData,
  FileDeleteResponses,
  FileDetailData,
  FileDetailResponses,
  FileDownloadData,
  FileDownloadResponses,
  FileDownloadUrlData,
  FileDownloadUrlResponses,
  FileLinkData,
  FileLinkResponses,
  FileListData,
  FileListResponses,
  FileSignedDownloadData,
  FileSignedDownloadResponses,
  FileSignedUploadData,
  FileSignedUploadResponses,
  FileUnlinkData,
  FileUnlinkResponses,
  FileUploadData,
  FileUploadResponses,
  FileUploadUrlData,
  FileUploadUrlResponses,
  GroupAssignPermissionData,
  GroupAssignPermissionResponses,
  GroupCreateData,
  GroupCreateResponses,
  GroupDetailData,
  GroupDetailResponses,
  GroupListData,
  GroupListResponses,
  GroupUpdateData,
  GroupUpdateResponses,
  JobAdminCancelExecutionData,
  JobAdminCancelExecutionResponses,
  JobAdminExecutionDetailData,
  JobAdminExecutionDetailResponses,
  JobAdminFireScheduleNowData,
  JobAdminFireScheduleNowResponses,
  JobAdminListDefinitionsData,
  JobAdminListDefinitionsResponses,
  JobAdminListExecutionsData,
  JobAdminListExecutionsResponses,
  JobAdminListSchedulesData,
  JobAdminListSchedulesResponses,
  JobAdminManualDispatchData,
  JobAdminManualDispatchResponses,
  JobAdminPauseScheduleData,
  JobAdminPauseScheduleResponses,
  JobAdminResumeScheduleData,
  JobAdminResumeScheduleResponses,
  JobAdminRetryExecutionData,
  JobAdminRetryExecutionResponses,
  MessagingWebhooksApiReceiveDlrPush1Data,
  MessagingWebhooksApiReceiveDlrPush1Errors,
  MessagingWebhooksApiReceiveDlrPush1Responses,
  MessagingWebhooksApiReceiveDlrPushData,
  MessagingWebhooksApiReceiveDlrPushResponses,
  MessagingWebhooksApiReceiveMoPush1Data,
  MessagingWebhooksApiReceiveMoPush1Errors,
  MessagingWebhooksApiReceiveMoPush1Responses,
  MessagingWebhooksApiReceiveMoPushData,
  MessagingWebhooksApiReceiveMoPushResponses,
  MobileMessageDetailData,
  MobileMessageDetailResponses,
  MobileMessageListData,
  MobileMessageListResponses,
  NomenclatureCreateItemData,
  NomenclatureCreateItemResponses,
  NomenclatureDeleteItemData,
  NomenclatureDeleteItemResponses,
  NomenclatureExportItemsData,
  NomenclatureExportItemsResponses,
  NomenclatureGetItemData,
  NomenclatureGetItemResponses,
  NomenclatureImportItemsData,
  NomenclatureImportItemsResponses,
  NomenclatureListItemsData,
  NomenclatureListItemsResponses,
  NomenclatureTypeCreateData,
  NomenclatureTypeCreateResponses,
  NomenclatureTypeDeleteData,
  NomenclatureTypeDeleteResponses,
  NomenclatureTypeDetailData,
  NomenclatureTypeDetailResponses,
  NomenclatureTypeListData,
  NomenclatureTypeListResponses,
  NomenclatureTypeUpdateData,
  NomenclatureTypeUpdateResponses,
  NomenclatureUpdateItemData,
  NomenclatureUpdateItemResponses,
  NotificationDetailData,
  NotificationDetailResponses,
  NotificationListData,
  NotificationListResponses,
  NotificationMarkAllReadData,
  NotificationMarkAllReadResponses,
  NotificationMarkReadData,
  NotificationMarkReadResponses,
  NotificationTestTriggerReportPublishedData,
  NotificationTestTriggerReportPublishedResponses,
  NotificationTestTriggerSmsSendData,
  NotificationTestTriggerSmsSendResponses,
  NotificationTestTriggerUserSignedUpData,
  NotificationTestTriggerUserSignedUpResponses,
  NotificationTestTriggerViberSendData,
  NotificationTestTriggerViberSendResponses,
  NotificationTypeListData,
  NotificationTypeListResponses,
  NotificationUnreadCountData,
  NotificationUnreadCountResponses,
  OrderAddLineItemData,
  OrderAddLineItemResponses,
  OrderCancelData,
  OrderCancelResponses,
  OrderCloseData,
  OrderCloseResponses,
  OrderConfirmData,
  OrderConfirmResponses,
  OrderCreateData,
  OrderCreateResponses,
  OrderDeleteData,
  OrderDeleteResponses,
  OrderDetailData,
  OrderDetailResponses,
  OrderFulfillData,
  OrderFulfillResponses,
  OrderGetLineItemData,
  OrderGetLineItemResponses,
  OrderListData,
  OrderListLineItemsData,
  OrderListLineItemsResponses,
  OrderListResponses,
  OrderMassCancelData,
  OrderMassCancelResponses,
  OrderMassConfirmData,
  OrderMassConfirmResponses,
  OrderRemoveLineItemData,
  OrderRemoveLineItemResponses,
  OrderSubmitData,
  OrderSubmitResponses,
  OrderUpdateData,
  OrderUpdateLineItemData,
  OrderUpdateLineItemResponses,
  OrderUpdateResponses,
  PaymentCheckoutTestCheckoutScenarioData,
  PaymentCheckoutTestCheckoutScenarioResponses,
  PaymentOrderCreateData,
  PaymentOrderCreateResponses,
  PaymentOrderDetailData,
  PaymentOrderDetailResponses,
  PaymentOrderIntentData,
  PaymentOrderIntentResponses,
  PaymentOrderListData,
  PaymentOrderListResponses,
  PaymentOrderSubmitData,
  PaymentOrderSubmitResponses,
  PaymentProviderCallbackCallbackData,
  PaymentProviderCallbackCallbackResponses,
  PodiumErrorHandle1Data,
  PodiumErrorHandle1Responses,
  PodiumErrorHandle2Data,
  PodiumErrorHandle2Responses,
  PodiumErrorHandle3Data,
  PodiumErrorHandle3Responses,
  PodiumErrorHandle4Data,
  PodiumErrorHandle4Responses,
  PodiumErrorHandle5Data,
  PodiumErrorHandle5Responses,
  PodiumErrorHandle6Data,
  PodiumErrorHandle6Responses,
  PodiumErrorHandleData,
  PodiumErrorHandleResponses,
  SendGridInboundWebhookHandleData,
  SendGridInboundWebhookHandleResponses,
  SendGridStatusWebhookHandleData,
  SendGridStatusWebhookHandleResponses,
  TemplateDetailData,
  TemplateDetailResponses,
  TemplateListData,
  TemplateListResponses,
  TemplatePreviewData,
  TemplatePreviewResponses,
  TemplateValidateData,
  TemplateValidateResponses,
  UserActivateData,
  UserActivateResponses,
  UserCreateData,
  UserCreateResponses,
  UserDeactivateData,
  UserDeactivateResponses,
  UserDeleteData,
  UserDeleteResponses,
  UserDetailData,
  UserDetailResponses,
  UserGroupsData,
  UserGroupsResponses,
  UserListData,
  UserListResponses,
  UserPermissionsData,
  UserPermissionsResponses,
  UserResetPasswordData,
  UserResetPasswordResponses,
  UserSetGroupsData,
  UserSetGroupsResponses,
  UserUpdateData,
  UserUpdateResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const userDelete = <ThrowOnError extends boolean = false>(
  options: Options<UserDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<UserDeleteResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/users/{id}",
      ...options,
    },
  );

export const userDetail = <ThrowOnError extends boolean = false>(
  options: Options<UserDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<UserDetailResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/users/{id}",
    ...options,
  });

export const userUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UserUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).put<UserUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/users/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const userGroups = <ThrowOnError extends boolean = false>(
  options: Options<UserGroupsData, ThrowOnError>,
) =>
  (options.client ?? client).get<UserGroupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/users/{id}/groups",
    ...options,
  });

export const userSetGroups = <ThrowOnError extends boolean = false>(
  options: Options<UserSetGroupsData, ThrowOnError>,
) =>
  (options.client ?? client).put<UserSetGroupsResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/users/{id}/groups",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

export const orderDelete = <ThrowOnError extends boolean = false>(
  options: Options<OrderDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    OrderDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}",
    ...options,
  });

export const orderDetail = <ThrowOnError extends boolean = false>(
  options: Options<OrderDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrderDetailResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}",
    ...options,
  });

export const orderUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OrderUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).put<OrderUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderRemoveLineItem = <ThrowOnError extends boolean = false>(
  options: Options<OrderRemoveLineItemData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    OrderRemoveLineItemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}/line-items/{itemId}",
    ...options,
  });

export const orderGetLineItem = <ThrowOnError extends boolean = false>(
  options: Options<OrderGetLineItemData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    OrderGetLineItemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}/line-items/{itemId}",
    ...options,
  });

export const orderUpdateLineItem = <ThrowOnError extends boolean = false>(
  options: Options<OrderUpdateLineItemData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    OrderUpdateLineItemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}/line-items/{itemId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const nomenclatureTypeDelete = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureTypeDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    NomenclatureTypeDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}",
    ...options,
  });

export const nomenclatureTypeDetail = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureTypeDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    NomenclatureTypeDetailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}",
    ...options,
  });

export const nomenclatureTypeUpdate = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureTypeUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    NomenclatureTypeUpdateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const nomenclatureDeleteItem = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureDeleteItemData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    NomenclatureDeleteItemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}/items/{id}",
    ...options,
  });

export const nomenclatureGetItem = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureGetItemData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    NomenclatureGetItemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}/items/{id}",
    ...options,
  });

export const nomenclatureUpdateItem = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureUpdateItemData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    NomenclatureUpdateItemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}/items/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const groupDetail = <ThrowOnError extends boolean = false>(
  options: Options<GroupDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<GroupDetailResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/groups/{id}",
    ...options,
  });

export const groupUpdate = <ThrowOnError extends boolean = false>(
  options: Options<GroupUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).put<GroupUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/groups/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const fileSignedUpload = <ThrowOnError extends boolean = false>(
  options: Options<FileSignedUploadData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    FileSignedUploadResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/files/signed-upload", ...options });

/**
 * Receive a mobile-originated SMS from NTH OmniChannel.
 *
 * NTH POSTs an `SmsMoMessageResource` here when an end user sends
 * an SMS to a long-number / sender-ID Podium owns. The receiver
 * MUST authenticate the request before trusting the payload.
 *
 * The path shown here is illustrative — Podium owns the actual
 * URL and provides it to NTH at service provisioning.
 *
 */
export const messagingWebhooksApiReceiveMoPush = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingWebhooksApiReceiveMoPushData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MessagingWebhooksApiReceiveMoPushResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/webhooks/nth/mo",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Receive a pushed delivery report from NTH OmniChannel.
 *
 * NTH POSTs a `DeliveryReportResource` here whenever the status of
 * a previously submitted MT message advances. The receiver MUST
 * authenticate the request — typically via HTTP Basic Auth on the
 * configured callback URL — before trusting the payload.
 *
 * The path shown here is illustrative; the actual callback URL is
 * owned by Podium and supplied to NTH either per-message (via the
 * outbound `dlrUrl` field on `MessageRequestResource`) or at
 * service provisioning.
 *
 */
export const messagingWebhooksApiReceiveDlrPush = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingWebhooksApiReceiveDlrPushData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MessagingWebhooksApiReceiveDlrPushResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/webhooks/nth/dlr",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Receive a mobile-originated message from msghub.cloud
 *
 * msghub.cloud POSTs MO (mobile-originated) messages here. Note that
 * Viber MO is only possible if the Viber Display Name is provisioned as
 * two-way.
 *
 * The receiver MUST verify `x-api-sign` before trusting the payload. If
 * MSISDN encryption is enabled on the service, the `msisdn` field is
 * an AES-256-CBC ciphertext: `base64( iv || ciphertext )`, key =
 * `api_secret`.
 *
 * Returning a non-200 response triggers retries on the msghub side. The
 * receiver MAY include `data.text` to synchronously reply back to the
 * end-user.
 *
 */
export const messagingWebhooksApiReceiveMoPush1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingWebhooksApiReceiveMoPush1Data, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MessagingWebhooksApiReceiveMoPush1Responses,
    MessagingWebhooksApiReceiveMoPush1Errors,
    ThrowOnError
  >({
    url: "/webhooks/msghub/mo",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Receive a pushed delivery report from msghub.cloud
 *
 * msghub.cloud POSTs a DLR event here whenever a message advances state
 * (sent → delivered, undelivered, rejected, etc.) and the message was
 * submitted with `registered_delivery: true` and/or a `callback_url`.
 *
 * The receiver MUST verify `x-api-sign` against the raw request body
 * before trusting the payload. Returning anything other than HTTP 200
 * with `meta.code: 200` triggers retries on the msghub side.
 *
 * The path shown here is illustrative — Podium owns the actual URL and
 * provides it to msghub.cloud either per-message or via service
 * provisioning.
 *
 */
export const messagingWebhooksApiReceiveDlrPush1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MessagingWebhooksApiReceiveDlrPush1Data, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MessagingWebhooksApiReceiveDlrPush1Responses,
    MessagingWebhooksApiReceiveDlrPush1Errors,
    ThrowOnError
  >({
    url: "/webhooks/msghub/dlr",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const boricaCallbackReceive = <ThrowOnError extends boolean = false>(
  options: Options<BoricaCallbackReceiveData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BoricaCallbackReceiveResponses,
    unknown,
    ThrowOnError
  >({
    querySerializer: { parameters: { params: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/webhooks/borica/callback",
    ...options,
  });

export const sendGridInboundWebhookHandle = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SendGridInboundWebhookHandleData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    SendGridInboundWebhookHandleResponses,
    unknown,
    ThrowOnError
  >({
    url: "/api/webhooks/email/sendgrid/inbound",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

export const sendGridStatusWebhookHandle = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SendGridStatusWebhookHandleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SendGridStatusWebhookHandleResponses,
    unknown,
    ThrowOnError
  >({
    url: "/api/webhooks/email/sendgrid/events",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const userList = <ThrowOnError extends boolean = false>(
  options?: Options<UserListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<UserListResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/users",
    ...options,
  });

export const userCreate = <ThrowOnError extends boolean = false>(
  options: Options<UserCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<UserCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const userResetPassword = <ThrowOnError extends boolean = false>(
  options: Options<UserResetPasswordData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UserResetPasswordResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/users/{id}/reset-password",
    ...options,
  });

export const userDeactivate = <ThrowOnError extends boolean = false>(
  options: Options<UserDeactivateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UserDeactivateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/users/{id}/deactivate",
    ...options,
  });

export const userActivate = <ThrowOnError extends boolean = false>(
  options: Options<UserActivateData, ThrowOnError>,
) =>
  (options.client ?? client).post<UserActivateResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/users/{id}/activate",
      ...options,
    },
  );

export const templateValidate = <ThrowOnError extends boolean = false>(
  options: Options<TemplateValidateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TemplateValidateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/templates/{code}/validate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const templatePreview = <ThrowOnError extends boolean = false>(
  options: Options<TemplatePreviewData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    TemplatePreviewResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/templates/{code}/preview",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const paymentProviderCallbackCallback = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PaymentProviderCallbackCallbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PaymentProviderCallbackCallbackResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/payment-providers/{provider}/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const paymentOrderList = <ThrowOnError extends boolean = false>(
  options?: Options<PaymentOrderListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    PaymentOrderListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/payment-orders",
    ...options,
  });

export const paymentOrderCreate = <ThrowOnError extends boolean = false>(
  options: Options<PaymentOrderCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PaymentOrderCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/payment-orders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const paymentOrderSubmit = <ThrowOnError extends boolean = false>(
  options: Options<PaymentOrderSubmitData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PaymentOrderSubmitResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/payment-orders/{id}/submit",
    ...options,
  });

export const paymentOrderIntent = <ThrowOnError extends boolean = false>(
  options: Options<PaymentOrderIntentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PaymentOrderIntentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/payment-orders/{id}/intent",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderList = <ThrowOnError extends boolean = false>(
  options?: Options<OrderListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<OrderListResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders",
    ...options,
  });

export const orderCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrderCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrderCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderSubmit = <ThrowOnError extends boolean = false>(
  options: Options<OrderSubmitData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrderSubmitResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}/submit",
    ...options,
  });

export const orderListLineItems = <ThrowOnError extends boolean = false>(
  options: Options<OrderListLineItemsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    OrderListLineItemsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}/line-items",
    ...options,
  });

export const orderAddLineItem = <ThrowOnError extends boolean = false>(
  options: Options<OrderAddLineItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    OrderAddLineItemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}/line-items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderFulfill = <ThrowOnError extends boolean = false>(
  options: Options<OrderFulfillData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrderFulfillResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/orders/{id}/fulfill",
      ...options,
    },
  );

export const orderConfirm = <ThrowOnError extends boolean = false>(
  options: Options<OrderConfirmData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrderConfirmResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/orders/{id}/confirm",
      ...options,
    },
  );

export const orderClose = <ThrowOnError extends boolean = false>(
  options: Options<OrderCloseData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrderCloseResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}/close",
    ...options,
  });

export const orderCancel = <ThrowOnError extends boolean = false>(
  options: Options<OrderCancelData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrderCancelResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderMassConfirm = <ThrowOnError extends boolean = false>(
  options: Options<OrderMassConfirmData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    OrderMassConfirmResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/mass-confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const orderMassCancel = <ThrowOnError extends boolean = false>(
  options: Options<OrderMassCancelData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    OrderMassCancelResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/orders/mass-cancel",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const notificationMarkRead = <ThrowOnError extends boolean = false>(
  options: Options<NotificationMarkReadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    NotificationMarkReadResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/notifications/mark-read",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const notificationMarkAllRead = <ThrowOnError extends boolean = false>(
  options?: Options<NotificationMarkAllReadData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    NotificationMarkAllReadResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/notifications/mark-all-read",
    ...options,
  });

export const nomenclatureTypeList = <ThrowOnError extends boolean = false>(
  options?: Options<NomenclatureTypeListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    NomenclatureTypeListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types",
    ...options,
  });

export const nomenclatureTypeCreate = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureTypeCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    NomenclatureTypeCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const nomenclatureListItems = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureListItemsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    NomenclatureListItemsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}/items",
    ...options,
  });

export const nomenclatureCreateItem = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureCreateItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    NomenclatureCreateItemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}/items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const nomenclatureImportItems = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureImportItemsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    NomenclatureImportItemsResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}/import",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

export const jobAdminResumeSchedule = <ThrowOnError extends boolean = false>(
  options: Options<JobAdminResumeScheduleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    JobAdminResumeScheduleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/schedules/{identity}/resume",
    ...options,
  });

export const jobAdminPauseSchedule = <ThrowOnError extends boolean = false>(
  options: Options<JobAdminPauseScheduleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    JobAdminPauseScheduleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/schedules/{identity}/pause",
    ...options,
  });

export const jobAdminFireScheduleNow = <ThrowOnError extends boolean = false>(
  options: Options<JobAdminFireScheduleNowData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    JobAdminFireScheduleNowResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/schedules/{identity}/fire-now",
    ...options,
  });

export const jobAdminRetryExecution = <ThrowOnError extends boolean = false>(
  options: Options<JobAdminRetryExecutionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    JobAdminRetryExecutionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/executions/{id}/retry",
    ...options,
  });

export const jobAdminCancelExecution = <ThrowOnError extends boolean = false>(
  options: Options<JobAdminCancelExecutionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    JobAdminCancelExecutionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/executions/{id}/cancel",
    ...options,
  });

export const jobAdminManualDispatch = <ThrowOnError extends boolean = false>(
  options: Options<JobAdminManualDispatchData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    JobAdminManualDispatchResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/dispatch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const groupList = <ThrowOnError extends boolean = false>(
  options?: Options<GroupListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GroupListResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/groups",
    ...options,
  });

export const groupCreate = <ThrowOnError extends boolean = false>(
  options: Options<GroupCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<GroupCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const groupAssignPermission = <ThrowOnError extends boolean = false>(
  options: Options<GroupAssignPermissionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GroupAssignPermissionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/groups/{id}/permissions/{permissionId}",
    ...options,
  });

export const fileList = <ThrowOnError extends boolean = false>(
  options?: Options<FileListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<FileListResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/files",
    ...options,
  });

export const fileUpload = <ThrowOnError extends boolean = false>(
  options?: Options<FileUploadData, ThrowOnError>,
) =>
  (options?.client ?? client).post<FileUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });

export const fileLink = <ThrowOnError extends boolean = false>(
  options: Options<FileLinkData, ThrowOnError>,
) =>
  (options.client ?? client).post<FileLinkResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/files/{id}/links",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const fileUploadUrl = <ThrowOnError extends boolean = false>(
  options: Options<FileUploadUrlData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    FileUploadUrlResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/files/upload-url",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const emailLinkUnlink = <ThrowOnError extends boolean = false>(
  options: Options<EmailLinkUnlinkData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    EmailLinkUnlinkResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails/{id}/unlink",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const emailLinkLink = <ThrowOnError extends boolean = false>(
  options: Options<EmailLinkLinkData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    EmailLinkLinkResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails/{id}/link",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const emailAttachmentSaveToFile = <ThrowOnError extends boolean = false>(
  options: Options<EmailAttachmentSaveToFileData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    EmailAttachmentSaveToFileResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails/{id}/attachments/{partIndex}/save-to-file",
    ...options,
  });

export const emailSend = <ThrowOnError extends boolean = false>(
  options: Options<EmailSendData, ThrowOnError>,
) =>
  (options.client ?? client).post<EmailSendResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails/send",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const paymentCheckoutTestCheckoutScenario = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PaymentCheckoutTestCheckoutScenarioData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PaymentCheckoutTestCheckoutScenarioResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/dev/payments/checkout-scenario",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

export const notificationTestTriggerViberSend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<NotificationTestTriggerViberSendData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    NotificationTestTriggerViberSendResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/dev/notifications/viber-send",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const notificationTestTriggerUserSignedUp = <
  ThrowOnError extends boolean = false,
>(
  options: Options<NotificationTestTriggerUserSignedUpData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    NotificationTestTriggerUserSignedUpResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/dev/notifications/user-signed-up",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const notificationTestTriggerSmsSend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<NotificationTestTriggerSmsSendData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    NotificationTestTriggerSmsSendResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/dev/notifications/sms-send",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const notificationTestTriggerReportPublished = <
  ThrowOnError extends boolean = false,
>(
  options: Options<NotificationTestTriggerReportPublishedData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    NotificationTestTriggerReportPublishedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/dev/notifications/report-published",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const authRefresh = <ThrowOnError extends boolean = false>(
  options?: Options<AuthRefreshData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AuthRefreshResponses, unknown, ThrowOnError>(
    {
      url: "/api/auth/refresh",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    },
  );

export const authLogout = <ThrowOnError extends boolean = false>(
  options?: Options<AuthLogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AuthLogoutResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/auth/logout",
    ...options,
  });

export const authLogoutAll = <ThrowOnError extends boolean = false>(
  options?: Options<AuthLogoutAllData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    AuthLogoutAllResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/auth/logout/all",
    ...options,
  });

export const authLogin = <ThrowOnError extends boolean = false>(
  options: Options<AuthLoginData, ThrowOnError>,
) =>
  (options.client ?? client).post<AuthLoginResponses, unknown, ThrowOnError>({
    url: "/api/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const boricaBridgeBridge = <ThrowOnError extends boolean = false>(
  options: Options<BoricaBridgeBridgeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    BoricaBridgeBridgeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/webhooks/borica/bridge",
    ...options,
  });

export const userPermissions = <ThrowOnError extends boolean = false>(
  options: Options<UserPermissionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    UserPermissionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/users/{id}/permissions",
    ...options,
  });

export const templateList = <ThrowOnError extends boolean = false>(
  options?: Options<TemplateListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<TemplateListResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/templates",
      ...options,
    },
  );

export const templateDetail = <ThrowOnError extends boolean = false>(
  options: Options<TemplateDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    TemplateDetailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/templates/{code}",
    ...options,
  });

export const paymentOrderDetail = <ThrowOnError extends boolean = false>(
  options: Options<PaymentOrderDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PaymentOrderDetailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/payment-orders/{id}",
    ...options,
  });

export const notificationList = <ThrowOnError extends boolean = false>(
  options?: Options<NotificationListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    NotificationListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/notifications",
    ...options,
  });

export const notificationDetail = <ThrowOnError extends boolean = false>(
  options: Options<NotificationDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    NotificationDetailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/notifications/{id}",
    ...options,
  });

export const notificationUnreadCount = <ThrowOnError extends boolean = false>(
  options?: Options<NotificationUnreadCountData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    NotificationUnreadCountResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/notifications/unread-count",
    ...options,
  });

export const notificationTypeList = <ThrowOnError extends boolean = false>(
  options?: Options<NotificationTypeListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    NotificationTypeListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/notification-types",
    ...options,
  });

export const nomenclatureExportItems = <ThrowOnError extends boolean = false>(
  options: Options<NomenclatureExportItemsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    NomenclatureExportItemsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/nomenclature-types/{typeCode}/export",
    ...options,
  });

export const mobileMessageList = <ThrowOnError extends boolean = false>(
  options?: Options<MobileMessageListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    MobileMessageListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/mobile-messages",
    ...options,
  });

export const mobileMessageDetail = <ThrowOnError extends boolean = false>(
  options: Options<MobileMessageDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    MobileMessageDetailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/mobile-messages/{id}",
    ...options,
  });

export const jobAdminListSchedules = <ThrowOnError extends boolean = false>(
  options?: Options<JobAdminListSchedulesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    JobAdminListSchedulesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/schedules",
    ...options,
  });

export const jobAdminListExecutions = <ThrowOnError extends boolean = false>(
  options?: Options<JobAdminListExecutionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    JobAdminListExecutionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/executions",
    ...options,
  });

export const jobAdminExecutionDetail = <ThrowOnError extends boolean = false>(
  options: Options<JobAdminExecutionDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    JobAdminExecutionDetailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/executions/{id}",
    ...options,
  });

export const jobAdminListDefinitions = <ThrowOnError extends boolean = false>(
  options?: Options<JobAdminListDefinitionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    JobAdminListDefinitionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/jobs/definitions",
    ...options,
  });

export const fileDelete = <ThrowOnError extends boolean = false>(
  options: Options<FileDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<FileDeleteResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/files/{id}",
      ...options,
    },
  );

export const fileDetail = <ThrowOnError extends boolean = false>(
  options: Options<FileDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<FileDetailResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/files/{id}",
    ...options,
  });

export const fileDownload = <ThrowOnError extends boolean = false>(
  options: Options<FileDownloadData, ThrowOnError>,
) =>
  (options.client ?? client).get<FileDownloadResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/files/{id}/download",
    ...options,
  });

export const fileDownloadUrl = <ThrowOnError extends boolean = false>(
  options: Options<FileDownloadUrlData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    FileDownloadUrlResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/files/{id}/download-url",
    ...options,
  });

export const fileSignedDownload = <ThrowOnError extends boolean = false>(
  options: Options<FileSignedDownloadData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    FileSignedDownloadResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/files/signed-download", ...options });

export const emailList = <ThrowOnError extends boolean = false>(
  options?: Options<EmailListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<EmailListResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails",
    ...options,
  });

export const emailDetail = <ThrowOnError extends boolean = false>(
  options: Options<EmailDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<EmailDetailResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails/{id}",
    ...options,
  });

export const emailAttachmentByIndex = <ThrowOnError extends boolean = false>(
  options: Options<EmailAttachmentByIndexData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    EmailAttachmentByIndexResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails/{id}/attachments/{partIndex}",
    ...options,
  });

export const emailAttachmentByContentId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<EmailAttachmentByContentIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    EmailAttachmentByContentIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails/{id}/attachments/by-cid/{contentId}",
    ...options,
  });

export const emailOutbox = <ThrowOnError extends boolean = false>(
  options?: Options<EmailOutboxData, ThrowOnError>,
) =>
  (options?.client ?? client).get<EmailOutboxResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails/outbox",
    ...options,
  });

export const emailInbox = <ThrowOnError extends boolean = false>(
  options?: Options<EmailInboxData, ThrowOnError>,
) =>
  (options?.client ?? client).get<EmailInboxResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/emails/inbox",
    ...options,
  });

export const auditEntries = <ThrowOnError extends boolean = false>(
  options?: Options<AuditEntriesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AuditEntriesResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/audit/entries",
      ...options,
    },
  );

export const auditConfig = <ThrowOnError extends boolean = false>(
  options?: Options<AuditConfigData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AuditConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/audit/config",
    ...options,
  });

export const auditAccessLog = <ThrowOnError extends boolean = false>(
  options?: Options<AuditAccessLogData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    AuditAccessLogResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/audit/access-log",
    ...options,
  });

export const fileUnlink = <ThrowOnError extends boolean = false>(
  options: Options<FileUnlinkData, ThrowOnError>,
) =>
  (options.client ?? client).delete<FileUnlinkResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/files/{id}/links/{type}/{objectId}",
      ...options,
    },
  );

export const podiumErrorHandle3 = <ThrowOnError extends boolean = false>(
  options?: Options<PodiumErrorHandle3Data, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    PodiumErrorHandle3Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/error",
    ...options,
  });

export const podiumErrorHandle = <ThrowOnError extends boolean = false>(
  options?: Options<PodiumErrorHandleData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    PodiumErrorHandleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/error",
    ...options,
  });

export const podiumErrorHandle5 = <ThrowOnError extends boolean = false>(
  options?: Options<PodiumErrorHandle5Data, ThrowOnError>,
) =>
  (options?.client ?? client).head<
    PodiumErrorHandle5Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/error",
    ...options,
  });

export const podiumErrorHandle6 = <ThrowOnError extends boolean = false>(
  options?: Options<PodiumErrorHandle6Data, ThrowOnError>,
) =>
  (options?.client ?? client).options<
    PodiumErrorHandle6Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/error",
    ...options,
  });

export const podiumErrorHandle4 = <ThrowOnError extends boolean = false>(
  options?: Options<PodiumErrorHandle4Data, ThrowOnError>,
) =>
  (options?.client ?? client).patch<
    PodiumErrorHandle4Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/error",
    ...options,
  });

export const podiumErrorHandle1 = <ThrowOnError extends boolean = false>(
  options?: Options<PodiumErrorHandle1Data, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PodiumErrorHandle1Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/error",
    ...options,
  });

export const podiumErrorHandle2 = <ThrowOnError extends boolean = false>(
  options?: Options<PodiumErrorHandle2Data, ThrowOnError>,
) =>
  (options?.client ?? client).put<
    PodiumErrorHandle2Responses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/error",
    ...options,
  });
